module.exports = __webpack_public_path__ + "img/bg_products.542367f1.png";